<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :currency-codes="currencyCodes"
            :currency-symbols="currencySymbols"
            :price-type-options="priceTypeOptions"
            :price-display-period-options="priceDisplayPeriodOptions"
            :price-symbol-position-options="priceSymbolPositionOptions"
            :price-symbol-separator-options="priceSymbolSeparatorOptions"
            :price-decimal-separator-options="priceDecimalSeparatorOptions"
            :price-thousands-separator-options="priceThousandsSeparatorOptions"
            :decimal-places-options="decimalPlacesOptions"
            :parent-options="parentOptions"
            :bank-account-options="bankAccountOptions"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/MarketRegions/Form'
import { route } from '~@/Composables/route'

defineProps({
    countries: {
        type: Array,
        default: () => { return [] }
    },
    currencyCodes: {
        type: Array,
        default: () => { return [] }
    },
    currencySymbols: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    priceTypeOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceDisplayPeriodOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceSymbolPositionOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceSymbolSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceDecimalSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceThousandsSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    decimalPlacesOptions: {
        type: Array,
        default: () => { return [] }
    },
    parentOptions: {
        type: Array,
        default: () => { return [] }
    },
    bankAccountOptions: {
        type: Array,
        default: () => { return [] }
    }
})

function submitData (form) {
    form.post(route('settings.market-regions.store'))
}
</script>
